import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import ContentContainer from '../ContentContainer';
import FooterColumn from '../FooterColumn';
import FooterItem from '../FooterItem';

let styles;

const INSTAGRAM = require('./instagram.svg');
const FACEBOOK = require('./facebook.svg');
const YOUTUBE = require('./youtube.svg');
const MAIL = require('./mail.svg');

export default class Footer extends Component {

  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer styles={styles.footer_container}>
          <FooterColumn title="About Us">
            <FooterItem title="Home" url="/" />
            <FooterItem title="Our Story" url="/story" />
            <FooterItem title="Dog e-Blog" url="/blog" />
          </FooterColumn>
          <FooterColumn title="Info">
            <FooterItem title="FAQs - Dog Owner" url="/faqs-dog-owner" />
            <FooterItem title="FAQs - Dog Borrower" url="/faqs-dog-borrower" />
            <FooterItem title="Contact Us" url="/contact" />
          </FooterColumn>
          <FooterColumn title="Terms">
            {!this.props.user && !this.props.user.isAuthenticated ? (
              <FooterItem title="Pricing" url="/join/subscription" />
            ) : null}
            <FooterItem title="Privacy Policy" url="/privacy" />
            <FooterItem title="Terms of Service" url="/terms" />
          </FooterColumn>
          <FooterColumn title="Connect with us">
            <div className={css(styles.footer_social)}>
              <a href="https://www.facebook.com/DogShareCollective" target="_blank" rel="noopener noreferrer">
                <img src={FACEBOOK} alt="Like us on Facebook" className={css(styles.social_icon)} />
              </a>
              <a href="https://www.instagram.com/dogsharecollective/" target="_blank" rel="noopener noreferrer">
                <img
                  src={INSTAGRAM}
                  alt="Follow us on Instagram"
                  className={css(styles.social_icon)} />
              </a>
              <a
                href="https://www.youtube.com/channel/UCw70BUCq4MvF7N8LqjjuyqA"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={YOUTUBE}
                  alt="Watch us on YouTube"
                  className={css(styles.social_icon, styles.youtube_icon)} />
              </a>
              <a
                href="mailto:support@thedogsharecollective.com"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={MAIL}
                  alt="Email us"
                  className={css(styles.social_icon, styles.mail_icon)} />
              </a>
            </div>
          </FooterColumn>
        </ContentContainer>
        <ContentContainer styles={styles.footer_container}>
          <p className={css(styles.copyright)}>Copyright &copy;
            The Dog Share Collective &trade;</p>
        </ContentContainer>
      </div>
    );
  }
}

Footer.propTypes = {
  user: PropTypes.object.isRequired,
};

styles = StyleSheet.create({
  container: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    bottom: 0,
    left: 0,
    paddingTop: 40,
    width: '100vw',
    height: Theme.footer.height,
    backgroundColor: Theme.footer.backgroundColor,

    [Theme.mobile_query]: {
      position: 'relative',
      height: 'auto',
    },
  },
  footer_container: {
    display: 'flex',
    paddingLeft: 70,
    paddingRight: 70,

    [Theme.mobile_query]: {
      flexWrap: 'wrap',
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  footer_social: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,

    [Theme.mobile_query]: {
      flexWrap: 'wrap',
    },
  },
  copyright: {
    color: '#fff',
    paddingBottom: '1rem',
    opacity: 0.6,
    fontSize: '0.9rem',
  },
  social_icon: {
    padding: 8,
  },
  youtube_icon: {
    width: 40,
    margin: '2px 0 0 0',
  },
  mail_icon: {
    width: 40,
    margin: '2px 0 0 0',
  },
});



// WEBPACK FOOTER //
// ./src/components/Footer/index.js